import { useEffect, useCallback, useState } from 'react';

import { alertStore, hideBottomAlert } from '@m/state/alert';
import theme from '@m/theme/theme';
import { useUnit } from 'effector-react';

import { AlertBox, AlertContainer } from './BottomAppAlert.styled';

import type { AlertContainerProps } from './BottomAppAlert.styled';

const ALERT_DURATION = 6000;

export default function BottomAppAlert(props: AlertContainerProps) {
  const [hideTimer, setHideTimer] = useState<number>();

  const { bottomAlert } = useUnit(alertStore);

  const { visible = false, label, type, customAlert, position } = bottomAlert || {};

  // Clear the previous timer if another timer is set
  useEffect(() => () => clearTimeout(hideTimer), [hideTimer]);

  useEffect(() => {
    if (visible) {
      const timer = window.setTimeout(() => {
        hideBottomAlert();
      }, ALERT_DURATION);
      setHideTimer(timer);
    }
  }, [visible, label, type]);

  const handleDismiss = useCallback(() => {
    hideBottomAlert();
    clearTimeout(hideTimer);
  }, [hideTimer]);

  return (
    <AlertBox visible={visible} position={position}>
      {customAlert || (
        <AlertContainer
          type="button"
          {...props}
          tabIndex={0}
          onTouchStart={handleDismiss}
          onMouseDown={handleDismiss}
          onKeyPress={handleDismiss}
          visible={visible}
          error={type === 'error'}
          warning={type === 'warning'}
          success={type === 'success'}
          infoBgColor={theme.colors.blue2}
          infoFgColor={theme.colors.blue7}
          successBgColor="#00A556"
          successFgColor="#fff"
          errorBgColor={theme.colors.coral}
          errorFgColor={theme.colors.orange1}
          warningBgColor={theme.colors.yellow1}
          warningFgColor={theme.colors.grey6}
        >
          {label}
        </AlertContainer>
      )}
    </AlertBox>
  );
}
